import { render, staticRenderFns } from "./CarrierVerificationSummary.vue?vue&type=template&id=450a150b&scoped=true&"
import script from "./CarrierVerificationSummary.vue?vue&type=script&lang=js&"
export * from "./CarrierVerificationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a150b",
  null
  
)

export default component.exports